import { useState } from 'react';

import ImportacaoRemuneracaoGerentes from '../../components/ImportacaoRemuneracaoGerentes/ImportacaoRemuneracaoGerentes';
import NotifierPopup from '../../components/NotifierPopup/NotifierPopup';

export default function RemuneracaoGerentesImportacao() {

    const [ notify, setNotify ] = useState({
        isActive: false,
        isSuccessful: undefined,
        message: undefined
    });


    return <>
        {notify.isActive &&
            <NotifierPopup
                notify={notify}
                setNotify={setNotify}
            />
        }
        <ImportacaoRemuneracaoGerentes setNotifier = {(isSuccess, message) => setNotify({
                isActive: true,
                isSuccessful: isSuccess,
                message: message
            })} />
    </>
}
